import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: 100vh;
`;